// extracted by mini-css-extract-plugin
module.exports = {"wrapperProfile":"UploadImageAvatar_wrapperProfile__3g2Pe","imageProfile":"UploadImageAvatar_imageProfile__Pv81C","iconUploadProfile":"UploadImageAvatar_iconUploadProfile__3qRLt"};